export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="https://akrivtech.com">
            <img
              src="img/akriv-logo.svg"
              alt="Akriv"
              style={{ height: "50px", width: "auto" }}
            />
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <div className="navbar-top">
            <ul className="nav navbar-nav">
              <li>
                <a href="#page-top" className="page-scroll" onClick={() => props.handleNavigate && props.handleNavigate("#page-top")}>
                  Home
                </a>
              </li>
              <li>
                <a href="#about" className="page-scroll" onClick={() => props.handleNavigate && props.handleNavigate("#about")}>
                  About
                </a>
              </li>
              <li>
                <a href="#services" className="page-scroll" onClick={() => props.handleNavigate && props.handleNavigate("#services")}>
                  Services
                </a>
              </li>
              <li>
                <a href="#contact" className="page-scroll" onClick={() => props.handleNavigate && props.handleNavigate("#contact")}>
                  Contact
                </a>
              </li>
            </ul>
            <ul className="navbar-right">
              <li>
                <a href="#contact" className="page-scroll" onClick={() => props.handleNavigate && props.handleNavigate("#contact")}>
                  Get Started
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};
